<template>
  <div>
    <el-dialog
        title="Liên kết tài khoản"
        :before-close="handleClose"
        :visible.sync="isOTPAuthenticationDialog"
        :close-on-click-modal="false"
        :show-close="false"
        width="600px"
        top="20vh"
        @open="handleOpen"
    >
      <el-form
          label-width="140px"
          :model="formData"
          label-position="left"
          :rules="rules"
          ref="formData"
      >
        <el-form-item label="Nhập mã OTP" prop="otp">
          <el-input v-model="formData.otp" placeholder="Nhập mã OTP" style="width: 400px;"></el-input>
<!--          <div style="margin-top: 10px;">-->
<!--            <span v-if="!resendAvailable">Gửi lại mã sau {{ countdown }} giây</span>-->
<!--            <el-button-->
<!--                v-else-->
<!--                type="text"-->
<!--                @click="resendOTP"-->
<!--            >-->
<!--              Gửi lại mã-->
<!--            </el-button>-->
<!--          </div>-->
        </el-form-item>
      </el-form>
      <div>
              <span slot="footer" class="dialog-footer">
          <el-button
              type="success"
              size="medium"
              :loading="loading.submit"
              style="width: 100%"
              @click="submitForm"
          >
            <i class="el-icon-circle-check"/>
            <span>Liên kết</span>
          </el-button>
      </span>
      </div>
      <div style="margin-top: 20px; text-align: center; font-size: 14px">
        Trong trường hợp không nhận được mã OTP hoặc mã OTP hết hiệu lực, bạn có thể nhấn
        <el-button
            type="primary"
            size="medium"
            :disabled="countdown > 0"
            @click="resendOTP"
            style="min-width: 100px"
        >
          {{ countdown > 0 ? `Gửi lại mã (${countdown}s)` : 'Gửi lại mã' }}
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>

import sePayConnectionService from "@/services/SePayConnectionService";
import NotifyMessage from "@/commonFuncion/NotifyMessage";

export default {
  name: "OTPAuthenticationDialog",
  props: {
    isOTPAuthenticationDialog: {
      type: Boolean,
      default: () => false
    },
    bank: {
      type: Object,
      default: () => null
    },
    response: {
      type: Object,
      default: () => null
    },
  },

  data() {
    return {
      formData: {
        otp: "",
        idBankAccount: 0,
        brandName: "",
        request_id: "",
      },
      data: {},
      countdown: 0,
      resendAvailable: false,
      timer: null,
      rules: {
        otp: [
          {
            required: true,
            message: "Mã OTP không được để trống!",
            trigger: "change",
          },
        ],
      },
      loading: {
        submit: false,
      },
    }
  },

  methods: {
    handleClose() {
      this.$refs["formData"].resetFields();
      this.$emit("closeDialog");
    },
    handleOpen() {
      this.formData.brandName = this.$props.bank.brandName;
      this.formData.idBankAccount = this.$props.response.id;
      this.formData.request_id = this.$props.response.data.request_id;
      this.startCountdown();
    },
    startCountdown() {
      this.resendAvailable = false;
      this.countdown = 30;
      this.timer = setInterval(() => {
        if (this.countdown > 0) {
          this.countdown--;
        } else {
          this.resendAvailable = true;
          clearInterval(this.timer);
        }
      }, 1000);
    },
    async resendOTP() {
      // Gọi API gửi lại mã OTP ở đây
      await sePayConnectionService.reloadAuthenticationOTP(this.formData).then((response) => {
        if (response.data.data.code === "200") {
          NotifyMessage.leftCornerNotificationSuccess("Đã gửi lại OTP xác thực. Vui lòng kiểm tra điện thoại!")
          this.formData.request_id = response.data.data.data.request_id;
        }
      })
      this.startCountdown(); // Bắt đầu đếm lại từ đầu
    },
    async submitForm() {
      this.$refs["formData"].validate(async (valid) => {
        if (valid) {
          this.loading.submit = true;
          await sePayConnectionService.authenticationOTP(this.formData).then((resp) => {
            if (resp.data.data === true) {
              NotifyMessage.leftCornerNotificationSuccess("Tạo mới thành công!")
              this.handleClose()
            }else {
              NotifyMessage.leftCornerNotificationError("Tạo mới thất bại!")
              this.handleClose()
            }
            this.loading.submit = false;
          }).catch((err) => {
            console.log(err);
          })

        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
  }
}
</script>

<style lang="scss" scoped>

</style>